class exports.InserterHandler extends Handler
    init: () ->
        @layoutUrl = 'backend/admin/inserter/load-layout-sidebar'
        @layoutSelector = App.sidebar.contentDiv()
        @singleSubHandler = true

        @subHandlers =
            'InserterDialog':
                'class': 'admin::handlers/inserter/InserterDialogHandler'

        @type = null

        @loadLayout()

    afterLoadLayout: (selector, data) ->
        ths = this

        $(selector).find('#div_ajax_loading').hide()

        $(selector).find('.type-btn').bind 'click', () ->
            ths.type = $(this).data('type')
            $(selector).find('.inserter-options').hide()
            $(selector).find('.' + ths.type + '-inserter-options').show()

        $(selector).find('#btn_start_upload').bind 'click', () ->
            return if $(this).hasClass('disabled') or not $(selector).find('#upload_form input[name="excel_file"]').val() or not ths.type?

            ths.destroyAllSubHandlers()
            hdn_forreal = $(selector).find('#upload_form input[name="hdn_forreal"]')

            extradata = $(selector).find('.' + ths.type + '-inserter-options form').serializeArray()
            typedata = {}
            for i in extradata
                typedata[i.name] = i.value

            typedata = ko.toJSON typedata

            # Build ajax data
            data = new FormData()
            data.append 'file', $(selector).find('#upload_form input[name="excel_file"]')[0].files[0]
            data.append 'forreal', hdn_forreal.val()
            data.append 'type', ths.type
            data.append 'type_data', typedata

            # Show loading gif
            $(selector).find('#div_ajax_loading').show()

            # Disable button
            $(this).addClass('disabled')

            # Show or hide additional text
            if hdn_forreal.val()
                $(selector).find('#foshizzle').show()
            else
                $(selector).find('#foshizzle').hide()
            hdn_forreal.val('')

            $.ajax
                url: 'backend/admin/inserter/handle-upload'
                type: 'POST'
                xhr: () ->
                    myXhr = $.ajaxSettings.xhr()
                    if myXhr.upload
                        myXhr.upload.addEventListener('progress', (e) ->
                            if e.lengthComputable
                                $('progress').attr({ value: e.loaded, max: e.total })
                        , false)
                    return myXhr
                data: data
                cache: false
                contentType: false
                processData: false
            .done (data) ->
                $(selector).find('#div_ajax_loading').hide()
                $(selector).find('#btn_start_upload').removeClass('disabled')
                json = null
                try
                    json = JSON.parse(data)
                catch e
                    json = data

                if json?
                    if json.status?.type is 'error'
                        writer = App.sidebar.messageWriter()
                        writer.message_writer('error', json.status.msg, 2)
                        $('progress').removeAttr('value max')
                    else
                        handler = ths.createSubHandler('InserterDialog')
                        if handler
                            handler.data = json
                            handler.type = ths.type
                            handler.loadLayoutPostOptions =
                                'type': ths.type
                                'forreal': json.doCommit and not json.exception?
                            handler.init()
